import {Modal, useStore} from '@/core'
import {BarGraph} from '@c/bar-graph'
import {IconButton} from '@c/icon-button'
import styles from './style.module.styl'

export const GraphCard = ({title, children}) => {
  const store = useStore()
  const [modal, setModal] = store.use(['modal'])
  return (
    <>
      <div
        role="button"
        tabIndex={0}
        className={styles.card}
        onClick={() => setModal(title)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModal(title) } }}
      >
        <IconButton className={styles.expand} icon='Expand' />
        <h2>{title}</h2>
        {children}
      </div>
      <Modal name={title} >
        <div className={styles.modal}>
          <h2>{title}</h2>
          {children}
        </div>
      </Modal>
    </>
  )
}
